@if (!item().hidden) {
  <li class="nav-item pcoded-menu-caption">
    <label>{{ item().name | translate }}</label>
  </li>
  @for (items of item().children; track items) {
    @if ((items.name || '').toLowerCase() !== 'inventory') {
      @if (items.type === 'collapse') {
        <app-nav-collapse [item]="items" [parentRole]="item().role" />
      }
      @if (items.type === 'item') {
        <app-nav-item [item]="items" [parentRole]="item().role" />
      }
    }
    <!-- Inventory menu block/component -->
    <!--
    @if ((items.name || '').toLowerCase() === 'inventory') {
      @if (items.type === 'collapse') {
        <app-nav-collapse [item]="items" [parentRole]="item().role" />
      }
      @if (items.type === 'item') {
        <app-nav-item [item]="items" [parentRole]="item().role" />
      }
    }
    -->
  }
}
